import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

interface GrantAccessToClientParams {
  clientId: string | number;
  campaignId: string;
}

export const GRANT_ACCESS_TO_CLIENT_MK = 'grantAccessToClientMK';

const grantAccessToClient = (body: GrantAccessToClientParams) => {
  return authFetch(`/Adviser/Campaigns/GetAccessToClient`, {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });
};

export const useGrantAccessToClientMutation = () => {
  return useMutation(grantAccessToClient);
};
